document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.btc-add-to-cart').forEach(function (button) {

    button.addEventListener('click', async function (e) {
      e.preventDefault();

      const originalText = this.innerHTML;
      const variantId = Number(this.dataset.variantId);

      if (!variantId) {
        console.error('Invalid variant ID:', this.dataset.variantId);
        return;
      }

      this.innerHTML = '<span class="btc-loader"></span>';
      this.disabled = true;

      try {
        const cartDrawer = document.querySelector('cart-drawer');
        const sectionId = cartDrawer?.dataset.sectionId;

        const response = await fetch(
          window.Shopify.routes.root + 'cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1
                }
              ],
              sections: sectionId
            })
          }
        );

        const responseText = await response.text();

        // console.log('Cart Add Status:', response.status);
        // console.log(
        //   'Cart Add Content-Type:',
        //   response.headers.get('content-type')
        // );
        // console.log('Cart Add Response:', responseText);

        if (!response.ok) {
          throw new Error(
            `Cart request failed (${response.status}): ${responseText.substring(0, 500)}`
          );
        }

        let data;

        try {
          data = JSON.parse(responseText);
        } catch (parseError) {
          throw new Error(
            `Non-JSON response from Shopify: ${responseText.substring(0, 500)}`
          );
        }

        //console.log('Product added successfully:', data);

        /*
         * Update cart drawer with freshly rendered section.
         */
        if (sectionId && data.sections && data.sections[sectionId]) {

          const currentDrawer = document.querySelector('cart-drawer');

          if (currentDrawer) {

            const parser = new DOMParser();
            const doc = parser.parseFromString(
              data.sections[sectionId],
              'text/html'
            );

            const newDrawer = doc.querySelector('cart-drawer');

            if (newDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
            } else {
              console.warn(
                'New cart-drawer element was not found in rendered section.'
              );
            }
          }

        } else {
          console.warn(
            'Cart drawer section was not returned.',
            {
              sectionId: sectionId,
              sections: data.sections
            }
          );
        }

        /*
         * Tell the theme that the cart has changed.
         */
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              cart: data
            }
          })
        );

        window.dispatchEvent(new Event('cart:refresh'));

        /*
         * Open the updated cart drawer.
         */
        const updatedCartDrawer = document.querySelector('cart-drawer');

        if (updatedCartDrawer) {
          if (typeof updatedCartDrawer.open === 'function') {
            updatedCartDrawer.open();
          } else {
            console.warn(
              'Cart drawer found, but open() method is not available.'
            );
          }
        }

        /*
         * Restore button.
         */
        setTimeout(() => {
          this.innerHTML = originalText;
          this.disabled = false;
        }, 500);

      } catch (error) {

        console.error('Add to cart error:', error);

        alert(
          "We couldn't add this product to your cart right now. Please try again."
        );

        this.innerHTML = originalText;
        this.disabled = false;
      }
    });

  });
});